import React from "react";
import { generateCRUDRoutes } from "../../../utils/index";

import { SafetyCertificateOutlined } from '@ant-design/icons';
import AccessRights from "./index";
import ViewAccessRight from "./view";
import EditAccessRight from "./edit";
import { MODULE_ACCESS_RIGHTS } from "variables/constants";

const accessRightsRoutes = [	
	generateCRUDRoutes({
		mainTitle: "Access Rights",
		basePath: "access-rights",
		mainComponent: <AccessRights />,
	    layout: "/console",	   
	    icon: <SafetyCertificateOutlined className="h-6 w-6" />,
	    subTitle:"Access Rights",
	    viewComponent: <ViewAccessRight />,
	    createComponent: <EditAccessRight />,
	    editComponent: <EditAccessRight />,
		level: 2,
		moduleId: MODULE_ACCESS_RIGHTS,
	})
]

export default accessRightsRoutes;